/* @generated */
// prettier-ignore
if (Intl.PluralRules && typeof Intl.PluralRules.__addLocaleData === 'function') {
  Intl.PluralRules.__addLocaleData({
    "data": {
      "nnh": {
        "categories": {
          "cardinal": ["one", "other"],
          "ordinal": ["other"]
        },
        "fn": function fn(n, ord) {
          if (ord) return 'other';
          return n == 1 ? 'one' : 'other';
        }
      }
    },
    "aliases": {},
    "parentLocales": {},
    "availableLocales": ["nnh"]
  });
}